import * as React from "react";

function EmptyIcon(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 65 60"
      {...{ ...props, ref }}
    ></svg>
  );
}

export default React.forwardRef(EmptyIcon);
